interface HeaderSearchProps {
    el: HTMLElement;
    props: {
        url: string;
        param: string;
        escapeFunction: boolean;
    };
}

const HeaderSearch = ({ el, props }: HeaderSearchProps): void => {
    const {
        url,
        param,
        escapeFunction,
    } = props;

    const search = (inputValue: string): void => {
        const searchUrl = `${url}?${param}=${inputValue}`;
        window.location.href = searchUrl;
    };

    const searchInput = el.querySelector('input') as HTMLInputElement;

    searchInput.addEventListener('keyup', ({ key }) => {
        if (key === 'Enter') {
            const searchValue = searchInput.value;
            search(searchValue);
        }

        if (escapeFunction && key === 'Escape') {
            el.classList.remove('is-open');
        }
    });
};

export default HeaderSearch;
